var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// @flow
// @ts-nocheck
import React, { Component } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
var Wrapper = styled(Link)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: block;\n  font-size: 0;\n  position: relative;\n"], ["\n  display: block;\n  font-size: 0;\n  position: relative;\n"])));
var Image = styled.img(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var SimpleBanner = /** @class */ (function (_super) {
    __extends(SimpleBanner, _super);
    function SimpleBanner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SimpleBanner.prototype.render = function () {
        var _a = this.props, imageUrl = _a.imageUrl, targetUrl = _a.targetUrl;
        var content = _jsx(Image, { src: imageUrl }, void 0);
        if (!Boolean(targetUrl)) {
            return content;
        }
        return _jsx(Wrapper, __assign({ to: targetUrl }, { children: content }), void 0);
    };
    return SimpleBanner;
}(Component));
export default SimpleBanner;
var templateObject_1, templateObject_2;
